const BASEURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

export default BASEURL;
// For development: REACT_APP_API_BASE_URL=http://localhost:5000/api


// const BASEURL = "https://graceland-backend-new.onrender.com/api";





// git config --global --unset credential.helper

// https://graceland-memorial-backend.onrender.com/api